import { Injectable } from '@angular/core';
import { AreaResource } from '../../models/api/area-resource.model';

@Injectable({
    providedIn: 'root'
})
export class AreaResourceService {

    constructor() { }

    public findResource(resources: AreaResource[], resourceName: string) {

        var resource = resources.find(r => r.resourceId === resourceName);
        return resource ? resource.value : (resourceName === 'badge-class' ? 'custom-area-badge-default' : null);

    }

}
